var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInboxThumb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#605DF7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8268 12.174H10.1093C9.2559 12.174 8.48851 12.6935 8.17158 13.4858L6.71781 17.1203C6.64688 17.2976 6.62598 17.491 6.65737 17.6793L7.50753 22.7803C7.59139 23.2834 8.02672 23.6522 8.53681 23.6522H23.4645C23.9746 23.6522 24.41 23.2834 24.4938 22.7803L25.344 17.6793C25.3754 17.491 25.3545 17.2976 25.2836 17.1203L23.8298 13.4858C23.5128 12.6935 22.7455 12.174 21.8921 12.174H20.1746",
    stroke: "white",
    strokeWidth: 1.56522,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7284 18.1739H24.4681L23.8672 21.7796C23.7624 22.4086 23.2182 22.8696 22.5806 22.8696H9.42077C8.78315 22.8696 8.23899 22.4086 8.13417 21.7796L7.53321 18.1739H11.2729C11.5459 18.1739 11.7839 18.3597 11.8501 18.6246C12.0905 19.5862 12.9546 20.2609 13.9458 20.2609H18.0555C19.0468 20.2609 19.9108 19.5862 20.1512 18.6246C20.2174 18.3597 20.4554 18.1739 20.7284 18.1739Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.56522
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.957,
    y: 3.82611,
    width: 2.08696,
    height: 6.26087,
    rx: 1.04348,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5981 12.7294C15.8068 12.9824 16.1944 12.9824 16.4031 12.7294L19.8149 8.59286C20.0955 8.25256 19.8535 7.73915 19.4124 7.73915H12.5888C12.1477 7.73915 11.9057 8.25256 12.1863 8.59286L15.5981 12.7294Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.8261,
    height: 27.8261,
    fill: "white",
    transform: "translate(2.08789 2.08698)"
  })))));
}

export default SvgInboxThumb;